import React, { useEffect } from 'react';

// Utilities
import API, { socketPurchases } from '../../../../utils/api';
import gaUtils from '../../../GAWrapper/GAWrapper';
import { waitUserCancelCashoutsPending } from '../../shared/utils/cashouts';

// Store
import usePaymentStore from '../../shared/store/use-payment-store';

// Hooks
import { useMuwePayment } from './use-muwe-payment';

// Components
import styles from './card.module.css';

// Modals
import {
  ModalExternalIframePayment,
  showModalExternalIframePayment,
} from '../../shared/components/modals/modal-external-iframe-payment';
import { showModalSuccessPayment } from '../../shared/components/modals/modal-success';
import { waitVerificationName } from '../../shared/components/modals/modal-verification-name';

// Assets
import muweBrand from './muwe-logo.png';

export const CardMuwe = props => {
  const { amount, isInvalidAmount } = usePaymentStore();
  const { isSubmitting, submitCardPaymentMuwe } = useMuwePayment();

  useEffect(() => {
    socketPurchases.on('purchase:completed', data => {
      const transaction = {
        amount: data.amount,
        provider: 'Muwe',
        transactionId: data?.trans_id,
      };

      API.trackPurchaseSuccessFB(transaction);
      gaUtils.trackUserPurchase(transaction);

      showModalExternalIframePayment({
        url: data.status_url,
        title: 'ABONO COMPLETADO',
      });

      showModalSuccessPayment({
        amount: data.amount,
        balance: data.balance,
        trans_id: data.trans_id,
      });

      if (props.dispatch) {
        props.updateUserInfo(props.dispatch);
      } else if (props.updateUserBalance) {
        props.updateUserBalance(data.balance);
      }
    });

    socketPurchases.on('purchase:failed', data => {
      showModalExternalIframePayment({
        url: data.status_url,
        title: 'Error',
      });
    });

    return () => {
      socketPurchases.off('purchase:completed');
      socketPurchases.off('purchase:failed');
    };
  }, []);

  const processPayment = async cardData => {
    if (isSubmitting || isInvalidAmount) return;

    try {
      // const isVerified = await waitVerificationName({
      //   title: 'Verificación de nombre',
      // });

      // if (!isVerified) {
      //   alert('Por favor, verifica tu cuenta para continuar.');
      //   return;
      // }

      const userCancell = await waitUserCancelCashoutsPending();

      if (userCancell) {
        return;
      }

      const response = await submitCardPaymentMuwe({
        card: {
          cardNumber: cardData.cardNumber,
          expirationMonth: cardData.expirationMonth,
          expirationYear: cardData.expirationYear,
          cvv: cardData.cvv,
        },
        other_amount: amount,
      });

      showModalExternalIframePayment({
        url: response.order.url,
        title: 'Pago con tarjeta',
      });
    } catch (error) {
      console.error('Error al procesar el pago:', error);
      alert('Error al procesar el pago. Por favor, intenta de nuevo.');
    }
  };

  return (
    <div className={styles.container}>
      <ModalExternalIframePayment />

      <p className={styles.instructions}>
        Haz clic en "Abonar" para completar los datos de tu tarjeta de crédito.
      </p>

      <div className={styles.buttonContainer}>
        <button
          type="button"
          className="payment-button"
          onClick={() => processPayment({})}
          disabled={isSubmitting || isInvalidAmount}
        >
          {isSubmitting ? 'Procesando...' : 'Abonar'}
        </button>
      </div>

      <p className={styles.muweText}>
        Los cargos a tu tarjeta de crédito serán realizados a través de{' '}
        <a href="https://www.muwe.mx/" target="_blank" rel="noopener noreferrer">
          Muwe
        </a>
        .
      </p>

      <p className={styles.muweText}>
        <a href="https://www.muwe.mx/" target="_blank" rel="noopener noreferrer">
          <img src={muweBrand} alt="Muwe" className={styles.muweBrand} />
        </a>
      </p>
    </div>
  );
};
